import * as _ from 'underscore';
import * as bootstrap from 'bootstrap';
/**
 * @class Util  utility functions
 */
const Utils = {
    onDOMContentLoaded: function (callback) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', callback);
        }
        else {
            callback();
        }
    },
    /**
     * sends a request to the specified url from a form. this will change the window location.
     * @param {string} path the path to send the post request to
     * @param {object} params the parameters to add to the url
     * @param {string} [method=post] the method to use on the form
     * @param {?string} target
     */
    post(path, params, method = 'post', target = null) {
        // The rest of this code assumes you are not using a library.
        // It can be made less verbose if you use one.
        const form = document.createElement('form');
        form.method = method;
        form.action = path;
        // csrf token
        params = {
            _token: document
                .querySelector('meta[name="csrf-token"]')
                ?.getAttribute('content'),
            ...params,
        };
        const addInput = (key, value) => {
            const hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = key;
            hiddenField.value = value;
            form.appendChild(hiddenField);
        };
        for (const key in params) {
            if (params.hasOwnProperty(key)) {
                if (typeof params[key] != 'string' && typeof params[key] != 'number') {
                    for (const nestedKey in params[key]) {
                        addInput(`${key}[${nestedKey}]`, params[key][nestedKey]);
                    }
                    continue;
                }
                addInput(key, params[key]);
            }
        }
        if (target !== null) {
            form.target = target;
        }
        document.body.appendChild(form);
        form.submit();
    },
    /**
     * Set defaults for options object
     * @param options
     * @param defaults
     * @returns {NonNullable<*>}
     */
    setDefaults(options, defaults) {
        return _.defaults({}, _.clone(options), defaults);
    },
    /**
     * Toast alert
     * @param {string} text Message
     * @param {object} [options] Options
     * @param {('success','warning','danger','info', 'light)} options.type Type of toast alert
     * @param {('success','warning','danger','info', 'light)} options.text Color of text
     * @param {number} options.timeout
     */
    toast(text, options = {}) {
        options = Utils.setDefaults(options, {
            type: 'success',
            text: 'dark',
            timeout: 5000,
        });
        let container = $('.toast-container');
        let dom = $(`<div role="alert" class="toast bs-toast bg-${options.type} border-0 text-white"></div>`);
        dom.append($(`<div class="toast-body text-${options.text}">${text}</div>`));
        dom.append($(`<button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>`));
        container.append(dom);
        let toast = new bootstrap.Toast(dom[0], {
            autohide: false,
        });
        toast.show();
        let timeout;
        const startTimeout = (time) => {
            timeout = setTimeout(() => {
                toast.hide();
                setTimeout(() => {
                    dom.remove();
                }, 1000);
            }, time);
        };
        dom.hover(function () {
            clearTimeout(timeout);
        }, function () {
            if (typeof options.timeout != 'undefined') {
                startTimeout(options.timeout - options.timeout / 2);
            }
        });
        startTimeout(options.timeout);
    },
    generateUrl(path) {
        const host = window.location.protocol + '//' + window.location.host;
        return host + '//' + path;
    },
};
export default Utils;
